import Discover from './discover'
import Store from './store'
import ProductDetails from './productDetails'

export default [
    Discover, 
    Store,
    ProductDetails
]